import { Redirect, Route } from 'react-router-dom'
import { SwitchWithError } from '../common/SwitchWithError'
import Loadable from 'react-loadable'
import { Loader } from 'components/core/loader'
import { DEV_ONLY } from 'common/globalConstants'

import Home from './Home'
import Demo from './Demo'
import { PrivateRoute } from 'pages/common/PrivateRoute'
import { UserRoles } from 'common/types'
import { ViewPartnerAdminsPage } from 'pages/administration/components/partner-management/ViewPartnerAdminPage'
import { ViewAdminGroupsPage } from 'pages/administration/components/partner-management/ViewAdminGroupsPage'

import { useScreenSizes } from 'hooks/use-screen-sizes/useScreenSizes'
import EventRegistrantsPage from 'pages/content/components/events/EventRegistrantsPage'
import JobsPage from 'pages/private-jobs/JobsPage'
import ReportedContentDetails from 'pages/administration/components/member-management/ReportedContentDetails'
import ReportedContentsList from 'pages/administration/components/member-management/reported-user-management/ReportedUserList'
import PrivateTestWrapper from 'pages/private-jobs/PrivateTestWrapper'
import AccountSettingsMobilePage from 'pages/profile/AccountSettingsMobilePage'
import EditProfileSettingsPage from 'pages/profile/components/edit-member-profile/EditProfileSettingsPage'
import EditNotificationsPage from 'pages/profile/components/edit-member-profile/EditNotificationsPage'
import { slugify } from 'common/utils/slugify'
import { AccountSettingsGroupItemName } from 'common/types/account-settings-drawer.types'
import { Fragment } from 'react'

//@ts-ignore
const Profile = Loadable({ loader: () => import('pages/profile/Profile'), loading: Loader })
//@ts-ignore
const Verification = Loadable({ loader: () => import('pages/settings/Verification'), loading: Loader })
//@ts-ignore
const PasswordChange = Loadable({ loader: () => import('pages/settings/PasswordChange'), loading: Loader })
//@ts-ignore
const SettingsRouter = Loadable({ loader: () => import('pages/settings/router'), loading: Loader })
//@ts-ignore
const AuthRouter = Loadable({ loader: () => import('pages/settings/authRouter'), loading: Loader })
//@ts-ignore
const Authenticator = Loadable({ loader: () => import('pages/settings/Authenticator'), loading: Loader })
//@ts-ignore
const ContentList = Loadable({ loader: () => import('pages/content/ContentList'), loading: Loader })
//@ts-ignore
const TagContentList = Loadable({ loader: () => import('pages/content/TagContentList'), loading: Loader })
//@ts-ignore
const ContentDetails = Loadable({ loader: () => import('pages/content/ContentDetails'), loading: Loader })
//@ts-ignore
const EventPage = Loadable({ loader: () => import('pages/content/components/events/EventsPage'), loading: Loader })
//@ts-ignore
const EventDetails = Loadable({ loader: () => import('pages/content/components/events/EventRouter'), loading: Loader })
//@ts-ignore
const SummitDetails = Loadable({ loader: () => import('pages/summit/SummitRouter'), loading: Loader })
//@ts-ignore
const Bfutr2023Details = Loadable({ loader: () => import('pages/summit/SummitRouter'), loading: Loader })
//@ts-ignore
const SearchPage = Loadable({ loader: () => import('pages/search/SearchResults'), loading: Loader })
//@ts-ignore
const PublicProfile = Loadable({ loader: () => import('pages/profile/PublicProfile'), loading: Loader })
//@ts-ignore
const ChatsPage = Loadable({ loader: () => import('components/page/direct-messaging/ChatsPage'), loading: Loader })
//@ts-ignore
const Pings = Loadable({ loader: () => import('pages/notifications/Pings'), loading: Loader })
//@ts-ignore
const Unsubscribe = Loadable({ loader: () => import('pages/auth/UnsubscribePage'), loading: Loader })
//@ts-ignore
const ReUnsubscribe = Loadable({ loader: () => import('pages/auth/ReSubscribePage'), loading: Loader })
//@ts-ignore
const Conversations = Loadable({ loader: () => import('components/page/direct-messaging/Conversations'), loading: Loader })
//@ts-ignore
const Channel = Loadable({ loader: () => import('pages/channels/Channel'), loading: Loader })
//@ts-ignore
const ChannelAdminPage = Loadable({ loader: () => import('pages/channels/ChannelAdminPage'), loading: Loader })
//@ts-ignore
const ChannelUsersPage = Loadable({ loader: () => import('pages/channels/ChannelUsersPage'), loading: Loader })
//@ts-ignore
const AddMembersMobilePage = Loadable({ loader: () => import('pages/channels/AddMembersMobilePage'), loading: Loader })
//@ts-ignore
const EditChannelContent = Loadable({ loader: () => import('pages/channels/EditChannelMobilePage'), loading: Loader })
//@ts-ignore
const ChannelsListMobilePage = Loadable({ loader: () => import('pages/channels/ChannelsListMobile'), loading: Loader })
//@ts-ignore
const Channels = Loadable({ loader: () => import('pages/channels/Channels'), loading: Loader })
//@ts-ignore
const ChannelSummaryPage = Loadable({ loader: () => import('pages/channels/ChannelSummaryPage'), loading: Loader })
//@ts-ignore
const CreateEvent = Loadable({
  loader: () => import('pages/administration/components/create-event/CreateEvent'),
  //@ts-ignore
  loading: Loader
})
//@ts-ignore
const CreateSummit = Loadable({
  loader: () => import('pages/administration/components/create-event/CreateSummit'),
  //@ts-ignore
  loading: Loader
})
//@ts-ignore
const ViewEmployees = Loadable({
  loader: () => import('pages/administration/components/user-management/ViewEmployees'),
  //@ts-ignore
  loading: Loader
})
//@ts-ignore
const ViewUserGroup = Loadable({
  loader: () => import('pages/administration/components/user-management/ViewUserGroup'),
  //@ts-ignore
  loading: Loader
})
//@ts-ignore
const ViewAdminUserGroup = Loadable({
  loader: () => import('pages/administration/components/partner-management/ViewSuperAdminUserGroup'),
  //@ts-ignore
  loading: Loader
})
//@ts-ignore
const AdminEventList = Loadable({
  loader: () => import('pages/administration/components/eventManagement/AdminEventList'),
  //@ts-ignore
  loading: Loader
})
//@ts-ignore
const AdminEventListTest = Loadable({
  loader: () => import('pages/administration/components/eventManagement/AdminEventListTest'),
  //@ts-ignore
  loading: Loader
})
//@ts-ignore
const AdminReportedList = Loadable({
  loader: () => import('pages/administration/components/member-management/AdminReportedList'),
  //@ts-ignore
  loading: Loader
})
//@ts-ignore
const CopyInviteUrlPage = Loadable({
  loader: () => import('pages/auth/components/invite-friends/CopyInviteUrlPage'),
  //@ts-ignore
  loading: Loader
})
//@ts-ignore
const SummitInvitePage = Loadable({ loader: () => import('pages/summit/SummitInvitePage'), loading: Loader })
//@ts-ignore
const FeedbackPage = Loadable({ loader: () => import('pages/auth/components/feedback/FeedbackPage'), loading: Loader })
//@ts-ignore
export const SearchFilterPage = Loadable({
  loader: () => import('pages/search/components/SearchFilterPage'),
  //@ts-ignore
  loading: Loader
})
//@ts-ignore
const ChangePasswordPage = Loadable({
  loader: () => import('pages/auth/components/change-password/ChangePasswordPage'),
  //@ts-ignore
  loading: Loader
})
//@ts-ignore
const CreatePostPage = Loadable({
  loader: () => import('pages/content/components/posts/create-post/CreatePostPage'),
  //@ts-ignore
  loading: Loader
})
//@ts-ignore
const SharedPostPage = Loadable({
  loader: () => import('pages/content/components/posts/share-post/SharedPostPage'),
  //@ts-ignore
  loading: Loader
})
//@ts-ignore
const CompanyPage = Loadable({ loader: () => import('pages/profile/Company'), loading: Loader })
//@ts-ignore
const SettingPage = Loadable({ loader: () => import('pages/profile/Settings'), loading: Loader })
//@ts-ignore
const CompanyBioPage = Loadable({ loader: () => import('pages/profile/CompanyBio'), loading: Loader })
//@ts-ignore
const GoalsPage = Loadable({ loader: () => import('pages/profile/Goals'), loading: Loader })
//@ts-ignore
const PreferencesPage = Loadable({ loader: () => import('pages/profile/Preferences'), loading: Loader })
//@ts-ignore
const SummaryPage = Loadable({ loader: () => import('pages/profile/Summary'), loading: Loader })
//@ts-ignore
const ReactionsPage = Loadable({
  loader: () => import('pages/content/components/posts/user-reactions/ReactionsPage'),
  //@ts-ignore
  loading: Loader
})
//@ts-ignore
const PartnerFollowersPage = Loadable({
  loader: () => import('pages/partner-followers/components/PartnerFollowersPage'),
  //@ts-ignore
  loading: Loader
})
//@ts-ignore
const EditProfilePage = Loadable({
  loader: () => import('pages/profile/components/edit-member-profile/EditMobileProfilePage'),
  //@ts-ignore
  loading: Loader
})
//@ts-ignore
const EditPreferencePage = Loadable({
  loader: () => import('pages/preferences/components/edit-preference/EditPreferencePage'),
  //@ts-ignore
  loading: Loader
})
//@ts-ignore
const MemberGoalPage = Loadable({ loader: () => import('pages/profile/MemberGoalsPage.tsx'), loading: Loader })
//@ts-ignore
const CareerSummaryPage = Loadable({ loader: () => import('pages/profile/CareerSummaryPage.tsx'), loading: Loader })
//@ts-ignore
const MemberBioPage = Loadable({ loader: () => import('pages/profile/MemberBio.tsx'), loading: Loader })
//@ts-ignore
const EditProfileMenuPage = Loadable({
  loader: () => import('pages/profile/components/edit-member-profile/editProfileMenuPage'),
  //@ts-ignore
  loading: Loader
})
//@ts-ignore
const SuggestedConnections = Loadable({
  loader: () => import('pages/connections/components/SuggestedConnectionsPage'),
  //@ts-ignore
  loading: Loader
})
//@ts-ignore
const CreateUserGroupPage = Loadable({
  loader: () => import('pages/administration/components/user-management/CreateUserGroupPage'),
  //@ts-ignore
  loading: Loader
})
const AdminPermissionsView = Loadable({
  loader: () => import('pages/administration/AdminPermissionsViewMobile/AdminViewPermissionsMobile'),
  //@ts-ignore
  loading: Loader
})
//@ts-ignore
const AssignAdminUsersPage = Loadable({
  loader: () => import('pages/administration/components/partner-management/AssignAdminUsersPage'),
  //@ts-ignore
  loading: Loader
})
//@ts-ignore
const JobApplicants = Loadable({ loader: () => import('pages/job-applicants/JobApplicants'), loading: Loader })
//@ts-ignore
const JobApplicantsMobile = Loadable({
  loader: () => import('pages/JobApplicantsMobile/JobApplicantsMobile'),
  //@ts-ignore
  loading: Loader
})
const JobApplicantDetails = Loadable({
  loader: () => import('pages/job-applicants/JobApplicantDetailsPage'),
  //@ts-ignore
  loading: Loader
})
//@ts-ignore
const CreateJobMobile = Loadable({ loader: () => import('pages/createJob/CreateJobPage'), loading: Loader })
//@ts-ignore
const EditJobMobile = Loadable({ loader: () => import('pages/createJob/EditJobPage'), loading: Loader })
//@ts-ignore
const RepostJobPage = Loadable({ loader: () => import('pages/createJob/RepostJobPage'), loading: Loader })
//@ts-ignore
const RenewJobPage = Loadable({ loader: () => import('pages/createJob/PartnerRenewJobPage'), loading: Loader })
//@ts-ignore
const ViewJobsPage = Loadable({ loader: () => import('pages/content/components/jobs/ViewJobsPage'), loading: Loader })

//@ts-ignore
const ViewJobDetailsPage = Loadable({
  loader: () => import('pages/content/components/jobs/ViewJobDetailsPage'),
  //@ts-ignore
  loading: Loader
})

//@ts-ignore
const MemberJobDetailsPage = Loadable({
  loader: () => import('pages/content/components/jobs/MemberJobDetailsPage'),
  //@ts-ignore
  loading: Loader
})
//@ts-ignore
const WebJobsPage = Loadable({ loader: () => import('pages/content/components/jobs/WebJobsPage'), loading: Loader })

const Connections = Loadable({
  loader: () => import('pages/member-connections/Connections'),
  //@ts-ignore
  loading: Loader
})

const AdminHomePage = Loadable({
  loader: () => import('pages/administration/components/AdminHomePage'),
  //@ts-ignore
  loading: Loader
})

const JobApplyMobilePage = Loadable({
  loader: () => import('pages/apply-job-mobile-page/ApplyJobMobilePage'),
  //@ts-ignore
  loading: Loader
})

const PartnerUserGroupPage = Loadable({
  loader: () => import('pages/administration/components/partner-management/PartnerUserGroupPage'),
  //@ts-ignore
  loading: Loader
})
const AccountSettingsPage = Loadable({
  loader: () => import('pages/profile/account-settings/AccountSettingsPage'),
  //@ts-ignore
  loading: Loader
})

//@ts-ignore
const UsageSummaryPage = Loadable({ loader: () => import('pages/profile/UsageSummaryPage'), loading: Loader })
//@ts-ignore
const SummitNudgePage = Loadable({ loader: () => import('pages/content/components/events/SummitNudgePage'), loading: Loader })

const HomeRouter = () => {
  const { isDevice } = useScreenSizes()
  return (
    <SwitchWithError>
      <Route exact path="/">
        <Home />
      </Route>
      <Route exact path="/register">
        <Home />
      </Route>
      <Route exact path="/partner/register">
        <Home />
      </Route>
      <Route exact path="/partner/login">
        <Home />
      </Route>
      <Route exact path="/configuration/:admin">
        <Home />
      </Route>
      {DEV_ONLY && (
        <Route exact path="/demo">
          <Demo />
        </Route>
      )}
      <PrivateRoute allowRoles={[UserRoles.Member, UserRoles.Partner, UserRoles.Admin]} path="/settings">
        <SettingsRouter />
      </PrivateRoute>
      <PrivateRoute allowRoles={[UserRoles.Member, UserRoles.Partner, UserRoles.Admin]} path="/settings/partner">
        <SettingsRouter />
      </PrivateRoute>
      <Route exact path="/authenticate">
        <AuthRouter />
      </Route>
      <Route path="/verification/:cipher">
        <Verification />
      </Route>
      <Route path="/password-reset/:cipher">
        <PasswordChange />
      </Route>
      <Route path="/authenticate/:sso/:role">
        <Authenticator />
      </Route>
      <Route path="/events">
        <EventPage />
      </Route>
      <Route path="/events/upcoming">
        <EventPage />
      </Route>
      <Route path="/events/registered">
        <EventPage />
      </Route>
      <Route path="/summit/:summitId">
        <SummitDetails />
      </Route>
      <Route path="/bfutr2023">
        <Bfutr2023Details />
      </Route>
      <Route path="/summit/:summitId/registrants">
        <EventRegistrantsPage />
      </Route>
      <Route path="/jobs/create-job">
        <CreateJobMobile />
      </Route>
      <Route path="/jobs/edit-job/:jobId">
        <EditJobMobile />
      </Route>
      <Route path={["/home/jobs", '/private-jobs']}>
        <Redirect to="/jobs" />
      </Route>
      <Route exact path="/jobs">
        <JobsPage />
      </Route>
      <Route path="/private/test/wrapper">
        <PrivateTestWrapper />
      </Route>
      <PrivateRoute
        allowRoles={[UserRoles.Member, UserRoles.Partner, UserRoles.Admin]}
        path="/member/jobs/apply-job/:jobId"
      >
        <JobApplyMobilePage />
      </PrivateRoute>
      <PrivateRoute 
        allowRoles={[UserRoles.Member, UserRoles.Partner, UserRoles.Admin]}
        path="/job/details/:jobSlug?/:jobId/apply=true" exact>
        <MemberJobDetailsPage />
      </PrivateRoute>
      <Route path="/job/details/:jobSlug?/:jobId" exact>
        <MemberJobDetailsPage />
      </Route>
      <Route path="/partner/jobs/repost-job/:jobId">
        <RepostJobPage />
      </Route>
      <PrivateRoute
        allowRoles={[UserRoles.Member, UserRoles.Partner, UserRoles.Admin]}
        path="/partner/jobs/renew-job/:jobId"
      >
        <RenewJobPage />
      </PrivateRoute>
      <Route path="/event/:eventId/registrants">
        <EventRegistrantsPage />
      </Route>
      <Route path="/event/:eventId">
        <EventDetails />
      </Route>
      <Route exact path="/unsubscribe/:userId/category/:category">
        <Unsubscribe />
      </Route>
      <Route exact path="/resubscribe/:userId/category/:category">
        <ReUnsubscribe />
      </Route>
      <PrivateRoute allowRoles={[UserRoles.Member, UserRoles.Partner, UserRoles.Admin]} exact path="/profile">
        <Profile />
      </PrivateRoute>
      <PrivateRoute allowRoles={[UserRoles.Member, UserRoles.Partner, UserRoles.Admin]} exact path="/messages">
        <ChatsPage />
      </PrivateRoute>
      <PrivateRoute allowRoles={[UserRoles.Member, UserRoles.Partner, UserRoles.Admin]} exact path="/pings">
        <Pings />
      </PrivateRoute>
      <PrivateRoute
        allowRoles={[UserRoles.Member, UserRoles.Partner, UserRoles.Admin]}
        exact
        path="/messages/:receiverId"
      >
        <Conversations />
      </PrivateRoute>
      <PrivateRoute allowRoles={[UserRoles.Member, UserRoles.Partner, UserRoles.Admin]} path="/search">
        <SearchPage />
      </PrivateRoute>
      <PrivateRoute allowRoles={[UserRoles.Member, UserRoles.Partner, UserRoles.Admin]} exact path="/profile/:userId">
        <PublicProfile />
      </PrivateRoute>
      <PrivateRoute allowRoles={[UserRoles.Member, UserRoles.Partner, UserRoles.Admin]} path="/connections">
        <Connections />
      </PrivateRoute>
      <PrivateRoute allowRoles={[UserRoles.Member, UserRoles.Partner, UserRoles.Admin]} path="/connections/received">
        <Connections />
      </PrivateRoute>
      <PrivateRoute allowRoles={[UserRoles.Member, UserRoles.Partner, UserRoles.Admin]} exact path="/feed">
        <ContentList index={0} />
      </PrivateRoute>
      <PrivateRoute allowRoles={[UserRoles.Member, UserRoles.Partner, UserRoles.Admin]} exact path="/feed/invite">
        <ContentList />
      </PrivateRoute>
      <PrivateRoute allowRoles={[UserRoles.Member, UserRoles.Partner, UserRoles.Admin]} exact path="/feed/jobs">
        <ContentList index={1} />
      </PrivateRoute>
      <PrivateRoute allowRoles={[UserRoles.Member, UserRoles.Partner, UserRoles.Admin]} exact path="/feed/teaspot">
        <ContentList index={0} />
      </PrivateRoute>
      <PrivateRoute allowRoles={[UserRoles.Member, UserRoles.Partner, UserRoles.Admin]} exact path="/feed/post/create">
        <ContentList />
      </PrivateRoute>
      <PrivateRoute allowRoles={[UserRoles.Member, UserRoles.Partner, UserRoles.Admin]} exact path="/feed/tag/:topic">
        <TagContentList />
      </PrivateRoute>
      <PrivateRoute allowRoles={[UserRoles.Member, UserRoles.Partner, UserRoles.Admin]} exact path="/feed/:receiverId">
        <ContentList />
      </PrivateRoute>
      <PrivateRoute
        allowRoles={[UserRoles.Member, UserRoles.Partner, UserRoles.Admin]}
        exact
        path="/feed/post/:contentId"
      >
        <ContentDetails />
      </PrivateRoute>
      <PrivateRoute
        allowRoles={[UserRoles.Member, UserRoles.Partner, UserRoles.Admin]}
        exact
        path="/post/log/:contentId"
      >
        <ContentDetails />
      </PrivateRoute>
      <PrivateRoute allowRoles={[UserRoles.Admin]} path="/admin/home">
        <AdminHomePage />
      </PrivateRoute>
      <PrivateRoute allowRoles={[UserRoles.Admin]} exact path="/admin/event/create">
        <CreateEvent />
      </PrivateRoute>
      <PrivateRoute allowRoles={[UserRoles.Admin]} exact path="/admin/event/create/:eventId">
        <CreateEvent />
      </PrivateRoute>
      <PrivateRoute allowRoles={[UserRoles.Admin]} exact path="/admin/summit/create">
        <CreateSummit />
      </PrivateRoute>
      <PrivateRoute allowRoles={[UserRoles.Admin]} exact path="/admin/summit/update/:eventId">
        <CreateSummit />
      </PrivateRoute>
      <PrivateRoute allowRoles={[UserRoles.Admin]} path="/admin/event/list">
        <AdminEventList />
      </PrivateRoute>
      <PrivateRoute allowRoles={[UserRoles.Member, UserRoles.Admin]} exact path="/private/test/event">
        <AdminEventListTest />
      </PrivateRoute>
      <PrivateRoute exact allowRoles={[UserRoles.Admin]} path="/admin/reported-content">
        <AdminReportedList />
      </PrivateRoute>
      <PrivateRoute allowRoles={[UserRoles.Admin]} path="/admin/reported-content/:reportId">
        <ReportedContentDetails />
      </PrivateRoute>
      <PrivateRoute allowRoles={[UserRoles.Admin]} path="/admin/reported-users">
        <ReportedContentsList />
      </PrivateRoute>
      <PrivateRoute allowRoles={[UserRoles.Admin]} path="/admin/user/employees">
        <ViewEmployees />
      </PrivateRoute>
      <PrivateRoute allowRoles={[UserRoles.Admin]} path="/admin/user/usergroup">
        <ViewUserGroup />
      </PrivateRoute>
      <PrivateRoute
        allowRoles={[UserRoles.Member, UserRoles.Admin, UserRoles.Partner]}
        path="/superAdmin/user/usergroup"
      >
        <ViewAdminUserGroup />
      </PrivateRoute>
      <PrivateRoute allowRoles={[UserRoles.Member, UserRoles.Admin]} exact path="/invite">
        <CopyInviteUrlPage />
      </PrivateRoute>
      <PrivateRoute allowRoles={[UserRoles.Member, UserRoles.Admin]} exact path="/summitInvite/:subTitle">
        <SummitInvitePage />
      </PrivateRoute>
      <PrivateRoute allowRoles={[UserRoles.Member, UserRoles.Admin]} exact path="/feedback">
        <FeedbackPage />
      </PrivateRoute>
      <PrivateRoute allowRoles={[UserRoles.Member, UserRoles.Admin]} path="/searchFilter">
        <SearchFilterPage />
      </PrivateRoute>
      <PrivateRoute allowRoles={[UserRoles.Member, UserRoles.Admin]} exact path="/changePassword">
        <ChangePasswordPage />
      </PrivateRoute>
      <PrivateRoute allowRoles={[UserRoles.Member, UserRoles.Admin]} exact path="/createPost">
        <CreatePostPage />
      </PrivateRoute>
      <PrivateRoute allowRoles={[UserRoles.Member, UserRoles.Admin]} exact path="/partner/createPost">
        <CreatePostPage />
      </PrivateRoute>
      <PrivateRoute
        allowRoles={[UserRoles.Member, UserRoles.Admin, UserRoles.Partner]}
        exact
        path="/post/share/:postId"
      >
        <SharedPostPage />
      </PrivateRoute>
      <PrivateRoute
        allowRoles={[UserRoles.Member, UserRoles.Admin, UserRoles.Partner]}
        exact
        path="/partner/post/share/:postId"
      >
        <SharedPostPage />
      </PrivateRoute>
      <PrivateRoute allowRoles={[UserRoles.Member, UserRoles.Admin]} exact path="/company/:partnerId">
        <CompanyPage />
      </PrivateRoute>
      <PrivateRoute allowRoles={[UserRoles.Member, UserRoles.Admin]} exact path="/company/:partnerId/admins">
        <ViewPartnerAdminsPage />
      </PrivateRoute>

      <PrivateRoute
        allowRoles={[UserRoles.Partner, UserRoles.Admin, UserRoles.Member]}
        exact
        path="/superAdmin/user/usergroup/users/:groupId"
      >
        <div />
      </PrivateRoute>

      <PrivateRoute allowRoles={[UserRoles.Member, UserRoles.Admin]} exact path="/:userId/admin">
        <ViewAdminGroupsPage />
      </PrivateRoute>
      <PrivateRoute allowRoles={[UserRoles.Member, UserRoles.Admin]} exact path="/editcompany/settings">
        <SettingPage />
      </PrivateRoute>
      <PrivateRoute allowRoles={[UserRoles.Member, UserRoles.Admin]} exact path="/editcompany/preferences">
        <PreferencesPage />
      </PrivateRoute>
      <PrivateRoute allowRoles={[UserRoles.Member, UserRoles.Admin]} exact path="/editcompany/goals">
        <GoalsPage />
      </PrivateRoute>
      <PrivateRoute allowRoles={[UserRoles.Member, UserRoles.Admin]} exact path="/editcompany/summary">
        <SummaryPage />
      </PrivateRoute>
      <PrivateRoute allowRoles={[UserRoles.Member, UserRoles.Admin]} exact path="/editcompany/companybio">
        <CompanyBioPage />
      </PrivateRoute>
      <PrivateRoute allowRoles={[UserRoles.Member, UserRoles.Admin]} exact path="/reactions/:contentId">
        <ReactionsPage />
      </PrivateRoute>
      <PrivateRoute allowRoles={[UserRoles.Partner, UserRoles.Member, UserRoles.Admin]} exact path="/partner/followers">
        <PartnerFollowersPage />
      </PrivateRoute>
      <PrivateRoute allowRoles={[UserRoles.Partner, UserRoles.Member, UserRoles.Admin]} exact path="/profile/edit">
        <EditProfilePage />
      </PrivateRoute>
      <PrivateRoute
        allowRoles={[UserRoles.Partner, UserRoles.Member, UserRoles.Admin]}
        path="/profile/edit/summit/:summitId"
      >
        <EditProfilePage />
      </PrivateRoute>
      <PrivateRoute
        allowRoles={[UserRoles.Partner, UserRoles.Member, UserRoles.Admin]}
        exact
        path="/edit/editPreferences"
      >
        <EditPreferencePage />
      </PrivateRoute>
      <PrivateRoute allowRoles={[UserRoles.Partner, UserRoles.Member, UserRoles.Admin]} exact path="/goals/memberGoals">
        <MemberGoalPage />
      </PrivateRoute>
      <PrivateRoute
        allowRoles={[UserRoles.Partner, UserRoles.Member, UserRoles.Admin]}
        exact
        path="/edit/editCareerSummary"
      >
        <CareerSummaryPage />
      </PrivateRoute>
      <PrivateRoute allowRoles={[UserRoles.Partner, UserRoles.Member, UserRoles.Admin]} exact path="/edit/MemberBio">
        <MemberBioPage />
      </PrivateRoute>
      <PrivateRoute allowRoles={[UserRoles.Partner, UserRoles.Member, UserRoles.Admin]} exact path="/edit/menu">
        <EditProfileMenuPage />
      </PrivateRoute>
      <PrivateRoute
        allowRoles={[UserRoles.Partner, UserRoles.Member, UserRoles.Admin]}
        exact
        path="/suggestedConnections"
      >
        <SuggestedConnections />
      </PrivateRoute>
      <PrivateRoute
        allowRoles={[UserRoles.Partner, UserRoles.Admin, UserRoles.Member]}
        path="/superAdmin/create/userGroup"
      >
        <CreateUserGroupPage />
      </PrivateRoute>
      <PrivateRoute
        allowRoles={[UserRoles.Partner, UserRoles.Admin, UserRoles.Member]}
        path="/superAdmin/edit/userGroup/:groupId"
      >
        <CreateUserGroupPage />
      </PrivateRoute>

      <PrivateRoute
        allowRoles={[UserRoles.Partner, UserRoles.Admin, UserRoles.Member]}
        path="/superAdmin/user-group/users/:groupId"
      >
        <PartnerUserGroupPage />
      </PrivateRoute>
      {isDevice && (
        <PrivateRoute
          allowRoles={[UserRoles.Partner, UserRoles.Admin, UserRoles.Member]}
          path="/superAdmin/view-permissions/userGroup/:groupId/:groupName"
        >
          <AdminPermissionsView />
        </PrivateRoute>
      )}
      <PrivateRoute
        allowRoles={[UserRoles.Partner, UserRoles.Member, UserRoles.Admin]}
        path="/admin/userGroup/addAdmin/:groupId"
      >
        <AssignAdminUsersPage />
      </PrivateRoute>
      <PrivateRoute
        allowRoles={[UserRoles.Partner, UserRoles.Member, UserRoles.Admin]}
        path="/job/partner/:jobId/applicants/:applicantId?"
      >
        <JobApplicants />
      </PrivateRoute>
      <PrivateRoute
        allowRoles={[UserRoles.Partner, UserRoles.Member, UserRoles.Admin]}
        path="/job/mobile/partner/:jobId/applicants/:applicantId?"
      >
        <JobApplicantsMobile />
      </PrivateRoute>

      <PrivateRoute allowRoles={[UserRoles.Member, UserRoles.Partner, UserRoles.Admin]} exact path="/partner/jobs">
        <WebJobsPage />
      </PrivateRoute>

      <PrivateRoute
        allowRoles={[UserRoles.Partner, UserRoles.Member, UserRoles.Admin]}
        exact
        path="/partner/jobs/:partnerId/details/:jobId"
      >
        <ViewJobDetailsPage />
      </PrivateRoute>

      <PrivateRoute
        allowRoles={[UserRoles.Partner, UserRoles.Member, UserRoles.Admin]}
        exact
        path="/partner/jobs/:jobId/applicants"
      >
        <JobApplicants />
      </PrivateRoute>

      <PrivateRoute
        allowRoles={[UserRoles.Partner, UserRoles.Member, UserRoles.Admin]}
        exact
        path="/partner/jobs/:jobId/applicant/:applicantId"
      >
        <JobApplicantDetails />
      </PrivateRoute>

      <PrivateRoute allowRoles={[UserRoles.Member, UserRoles.Partner, UserRoles.Admin]} path="/usage-summary">
        <UsageSummaryPage />
      </PrivateRoute>
      <PrivateRoute allowRoles={[UserRoles.Member, UserRoles.Partner, UserRoles.Admin]} exact path="/channel/select">
        <ChannelsListMobilePage />
      </PrivateRoute>
      <PrivateRoute allowRoles={[UserRoles.Member, UserRoles.Partner, UserRoles.Admin]} exact path="/channels">
        <Channels />
      </PrivateRoute>

      <PrivateRoute
        allowRoles={[UserRoles.Member, UserRoles.Partner, UserRoles.Admin]}
        exact
        path="/channel/:channelId/summary/"
      >
        <ChannelSummaryPage />
      </PrivateRoute>
      <PrivateRoute
        allowRoles={[UserRoles.Member, UserRoles.Partner, UserRoles.Admin]}
        exact
        path="/channel/:channelId/settings/"
      >
        <ChannelAdminPage />
      </PrivateRoute>
      <PrivateRoute
        allowRoles={[UserRoles.Member, UserRoles.Partner, UserRoles.Admin]}
        exact
        path="/channel/:channelId/users"
      >
        <ChannelUsersPage />
      </PrivateRoute>
      <PrivateRoute
        allowRoles={[UserRoles.Member, UserRoles.Partner, UserRoles.Admin]}
        exact
        path="/channel/:channelId/add-members"
      >
        <AddMembersMobilePage />
      </PrivateRoute>
      <PrivateRoute
        allowRoles={[UserRoles.Member, UserRoles.Partner, UserRoles.Admin]}
        exact
        path="/channel/:channelId/edit-channel"
      >
        <EditChannelContent />
      </PrivateRoute>
      <PrivateRoute
        allowRoles={[UserRoles.Member, UserRoles.Partner, UserRoles.Admin]}
        exact
        path="/channel/:channelId"
      >
        <Channel />
      </PrivateRoute>
      <PrivateRoute allowRoles={[UserRoles.Member, UserRoles.Partner, UserRoles.Admin]} exact path="/reminder/summit">
        <SummitNudgePage />
      </PrivateRoute>
      <PrivateRoute allowRoles={[UserRoles.Member, UserRoles.Partner, UserRoles.Admin]} path="/account-settings-mobile">
        <AccountSettingsMobilePage />
      </PrivateRoute>
      <PrivateRoute allowRoles={[UserRoles.Member, UserRoles.Partner, UserRoles.Admin]} path="/edit-profile">
        <EditProfileSettingsPage />
      </PrivateRoute>
      <PrivateRoute allowRoles={[UserRoles.Member, UserRoles.Partner, UserRoles.Admin]} path="/edit-notifications">
        <EditNotificationsPage />
      </PrivateRoute>
      {
        isDevice ? (<>
          <PrivateRoute allowRoles={[UserRoles.Member, UserRoles.Partner, UserRoles.Admin]} path="/account-settings/:slug?">
            <AccountSettingsPage />
          </PrivateRoute>
        </>) : <>
        <PrivateRoute allowRoles={[UserRoles.Member, UserRoles.Partner, UserRoles.Admin]} exact path="/account-settings">
          <Redirect to={`/account-settings/${slugify(AccountSettingsGroupItemName.EDIT_PROFILE)}`} />
        </PrivateRoute>
        <PrivateRoute allowRoles={[UserRoles.Member, UserRoles.Partner, UserRoles.Admin]} path="/account-settings/:slug">
          <AccountSettingsPage />
        </PrivateRoute>
        </>
      }
    </SwitchWithError>
  )
}

export default HomeRouter
